export default function () {
  return (
    <div className="container mx-auto">
      <div
        style={{ position: "relative", overflow: "hidden" }}
        className="relative overflow-hidden"
      >
        <a
          href="https://yandex.ru/maps/org/krasny_shar/64610307855/?utm_medium=mapframe&utm_source=maps"
          // style="color:#eee;font-size:12px;position:absolute;top:0px;"
          style={{
            color: "#eee",
            fontSize: "12px",
            position: "absolute",
            top: 0,
          }}
        >
          Красный шар
        </a>
        <a
          href="https://yandex.ru/maps/62/krasnoyarsk/category/goods_for_holiday/184108317/?utm_medium=mapframe&utm_source=maps"
          style={{
            color: "#eee",
            fontSize: "12px",
            position: "absolute",
            top: "14px",
          }}
        >
          Товары для праздника в Красноярске
        </a>

        <iframe src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=45613065956" width="100%" height="400" frameborder="0" allowfullscreen="true"
          style={{ position: "relative" }}></iframe>
      </div>
    </div>
  );
}
